import PubSub from "underpub-js";

var BannerButton = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-BannerButton',
	};

	$.extend(true, this.options, options);

};

BannerButton.prototype.init = function() {

	var self = this;

};

export default BannerButton;
